import { createSlice } from "@reduxjs/toolkit";

const firestoreSlice = createSlice({
  name: "firestore",
  initialState: {
    ordered: {},
    data: {},
  },
  reducers: {
    setFirestoreData: (state, action) => {
      const { collection, data, ordered, storeAs } = action.payload;
      const key = storeAs || collection;
      state.data[key] = data;
      state.ordered[key] = ordered;
    },

  },
});

export const { setFirestoreData } = firestoreSlice.actions;
export default firestoreSlice.reducer;
